import { ReactNode } from "react"
import Carousel from "../carousel/Carousel"

type Props = {
    children: ReactNode | ReactNode[]
    onPageChange?: (page: number) => void 
    className?: string
}

function CarouselGroup({ children, onPageChange, className }: Props) {
    return Array.isArray(children) && children.length > 1 ? (
        <Carousel timeout={10000} itemsPerPage={1} innerPaginator onPageChange={onPageChange} className={className}>
            {children}
        </Carousel>
    ) : (
        children
    )
}

export default CarouselGroup
